import { useMemo } from 'react';
import { Option } from 'components/atoms/select';
import { useNativeActiveOrInvitedUsersQuery } from 'queries/members';
import { byLabel } from 'utils/comparators/by-label';
import { fullName } from 'utils/full-name';
import { getRandomColor } from 'utils/get-random-color';

export const useUserOptions = (): [boolean, Option[]] => {
  const { data: users, isLoading: isUserOptionsLoading } =
    useNativeActiveOrInvitedUsersQuery();
  const userOptions = useMemo(
    () =>
      (users ?? [])
        .map((user) => ({
          label: fullName(user),
          value: user.userId,
          imageUrl: user.photoUrl,
          description: user.role?.roleName,
          color: getRandomColor(user.userId),
        }))
        .sort(byLabel),
    [users],
  );

  return [isUserOptionsLoading, userOptions];
};
